var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{staticClass:"grid"}),_c('Menu'),_c('StartCreate'),_c('StatCreate'),_c('WhoCanBe'),_c('WhatYouNeed'),_c('HowMuch'),_c('WeHelp'),_c('HowToStart'),_c('OurHeroes'),_c('BecomeCreate'),_c('QuestionsCreate'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }